/**
 * authSession — geçerli Supabase access token için SENKRON SSoT (errorLogger içindir).
 * ==================================================================================
 * `supabase.auth.getSession()` ASYNC → erken-render hatası oturum hydrate olmadan loglanınca token
 * null döner → ErrorLog.userId=anon (SablonKapak vakası). Bu modül `onAuthStateChange` ile token'ı
 * SENKRON cache'ler → hata anında beklemeden hazır. Backend token'dan userId'yi çözer (client userId
 * GÖNDERMEZ = spoof-güvenli). Token yenilenince (autoRefreshToken) TOKEN_REFRESHED eventi cache'i tazeler.
 *
 * ⚠️ axiosConfig KASITLI olarak buraya GEÇMEZ: API isteği her seferinde `getSession()` await eder
 * (taze/refresh-garantili token). Cache YALNIZ senkron-gereken erken-hata yolu içindir — API'de cache'e
 * güvenmek bayat token riski getirir. İki erişim de aynı Supabase session'dan okur (2 SSoT değil, tek kaynak).
 */
import type { Session } from '@supabase/supabase-js';
import { supabase } from './supabaseClient';

interface AuthSessionWindow extends Window {
  __AUTH_SESSION_SUB__?: boolean;
}

let _accessToken: string | null = null;

function _set(session: Session | null | undefined): void {
  _accessToken = session?.access_token || null;
}

// Tek abonelik — window guard'ı dev Fast-Refresh'te modül yeniden değerlendirilince çift-abonelik
// oluşmasını önler (initErrorLogger'daki window.__ERROR_LOGGER_INITIALIZED__ deseniyle hizalı). SSR'da
// (typeof window === 'undefined') hiç çalışmaz → server'da abonelik/localStorage erişimi yok, patlamaz.
if (typeof window !== 'undefined' && !(window as AuthSessionWindow).__AUTH_SESSION_SUB__) {
  (window as AuthSessionWindow).__AUTH_SESSION_SUB__ = true;
  supabase.auth
    .getSession()
    .then(({ data }) => {
      if (!_accessToken) _set(data?.session); // onAuthStateChange daha erken doldurduysa üzerine yazma
    })
    .catch(() => {
      /* oturum yoksa anonim devam */
    });
  // Event-agnostik: SIGNED_IN / TOKEN_REFRESHED / SIGNED_OUT / USER_UPDATED hepsinde token güncellenir.
  supabase.auth.onAuthStateChange((_event, session) => _set(session));
}

/** Geçerli access token (senkron, cache'li). Yoksa null → anonim loglanır. */
export function getAccessToken(): string | null {
  return _accessToken;
}
